import type { KinnserPullSummary } from '../../services/api/types.gen';
import type { ResolvedDemoContent } from './demoContent';

type KinnserSourceKind = keyof ResolvedDemoContent['kinnser_sources'];

/** How many rows the pull carried of a kind. */
export function pulledCount(
  pull: KinnserPullSummary | null | undefined,
  kind: KinnserSourceKind
): number {
  if (!pull) return 0;
  if (kind === 'clinics') return pull.clinics;
  if (kind === 'payers') return pull.insurances;
  if (kind === 'physicians') return pull.physicians;
  // Absent on a pull saved before staff was counted, which reads as none.
  return pull.staff ?? 0;
}

/**
 * How many of the clinics this build leaves out the latest pull still has.
 *
 * The leave-out list keeps ids from earlier pulls, including clinics the
 * agency has since closed, so subtracting its whole size from the pull's
 * clinic count can read as zero or a negative number while every clinic below
 * is still ticked.
 */
export function excludedInPull(
  pull: KinnserPullSummary | null | undefined,
  excluded: ReadonlySet<string>
): number {
  return (pull?.clinic_list ?? []).filter(clinic =>
    excluded.has(clinic.clinic_id)
  ).length;
}
